App.ThemePreviewComponent = Em.Component.extend App.RegistrableMixin,
  env: Em.inject.service('environment')

  classNames: 'theme-preview-component'

  skin: null
  organization: null

  iframeIsLoading: true

  baseUrl: (->
    previewTemplate = @get('env.themePreviewUrl')
    organization_id = @get('organization.id')

    previewTemplate.replace('{id}', organization_id) + '/'
  ).property(
    'organization.id',
    'env.themePreviewUrl')

  iframeUrl: (->
    baseUrl = @get('baseUrl')
    skinSid = @get('skin.secure_id')

    iframeUrl = "#{baseUrl}?preview=true"

    if skinSid
      iframeUrl += "&skin=#{skinSid}"

    iframeUrl
  ).property(
    'baseUrl',
    'skin.secure_id')

  iframeUrlChanged: (->
    @set('iframeIsLoading', true)
  ).observes('iframeUrl')

  didInsertElement: ->
    @$('iframe').load =>
      @set('iframeIsLoading', false)


  refreshIframe: ->
    @set('iframeIsLoading', true)
    iframe = @$('iframe')[0]
    iframe.src = iframe.src

  actions:
    reload: ->
      Em.run.debounce(@, @refreshIframe, 300)
      false